module.exports=function(scope){ return `<string name="zoom_accessibility_cancel_button">Cancel</string>
`};


// WEBPACK FOOTER //
// ./src/resources/code/android/38-customization-accessibility.java.tpl